import { API_BASE_URL } from "../config";
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  OutlinedInput,
  ListItemText,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";

const UploadFileModal = ({ open, onClose, onSubmit }) => {
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [forAllUsers, setForAllUsers] = useState(false);
  const [file, setFile] = useState(null);

  useEffect(() => {
    if (open) {
      fetch(`${API_BASE_URL}/api/admin/users`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include",
      })
        .then((res) => res.json())
        .then((data) => {
          const list = Array.isArray(data)
            ? data
            : Array.isArray(data?.users)
            ? data.users
            : [];
          setUsers(list);
        })
        .catch((err) => console.error("Failed to fetch users", err));
    }
  }, [open]);

  const handleSubmit = () => {
    if (!file) return alert("Fajl nije odabran");

    const formData = new FormData();
    formData.append("file", file);

    if (!forAllUsers && selectedUsers.length > 0) {
      selectedUsers.forEach((userId) => {
        formData.append("userIds[]", userId);
      });
    }

    console.log("📦 selectedUsers:", selectedUsers);
    onSubmit(formData);

    // Reset
    setSelectedUsers([]);
    setForAllUsers(false);
    setFile(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Upload File</DialogTitle>
      <DialogContent>
        <FormControlLabel
          control={
            <Checkbox
              checked={forAllUsers}
              onChange={(e) => setForAllUsers(e.target.checked)}
            />
          }
          label="For all users"
        />

        {!forAllUsers && (
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Users</InputLabel>
            <Select
              style={{ borderRadius: 20 }}
              multiple
              value={selectedUsers}
              onChange={(e) => {
                const value = e.target.value;
                const normalized = Array.isArray(value)
                  ? value.map((v) => String(v))
                  : [String(value)];
                setSelectedUsers(normalized);
              }}
              input={<OutlinedInput label="Users" />}
              renderValue={(selected) =>
                Array.isArray(users)
                  ? users
                      .filter((u) => selected.includes(String(u.id)))
                      .map((u) => u.name)
                      .join(", ")
                  : ""
              }
            >
              {Array.isArray(users) &&
                users.map((user) => (
                  <MenuItem key={user.id} value={String(user.id)}>
                    <Checkbox
                      checked={selectedUsers.includes(String(user.id))}
                    />
                    <ListItemText primary={`${user.name} (${user.email})`} />
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        )}

        <FormControl fullWidth sx={{ mt: 3 }}>
          <input
            type="file"
            id="hidden-upload"
            style={{ display: "none" }}
            onChange={(e) => {
              setFile(e.target.files?.[0] || null);
            }}
          />
          <label htmlFor="hidden-upload">
            <Button
              style={{ borderRadius: 20 }}
              variant="outlined"
              component="span"
              startIcon={<UploadFileIcon />}
              fullWidth
            >
              {file ? file.name : "Select file"}
            </Button>
          </label>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          style={{
            background: "var(--gradient-color)",
            color: "#000",
            borderRadius: 20,
          }}
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadFileModal;
